import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { LegalDocument } from "../../pages/public/LegalPage";
import { LegalLinks, MerchantBlock } from "./LegalLinks";
import { CardMarks } from "../payments/CardMarks";

const LOGO = `${process.env.PUBLIC_URL || ""}/brand/logo-480.webp`;

// Shown while the site gate is on: legal pages and the merchant block stay public for bank reviewers.
export function GateFooter() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/public/legal").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  return (
    <footer className="border-t-4 border-[#D4AF37] bg-[#081B33] text-white" data-testid="gate-footer">
      <div className="mx-auto flex max-w-5xl flex-col gap-6 px-6 py-8 text-sm md:flex-row md:justify-between">
        <LegalLinks pages={d.pages} prefix="gate" className="flex flex-wrap gap-x-6 gap-y-2" linkClass="text-white/90 underline-offset-4 hover:text-[#D4AF37] hover:underline" />
        <div className="flex flex-col gap-4 md:items-end">
          <MerchantBlock m={d.merchant} prefix="gate" className="text-white/80 md:text-right" />
          <CardMarks tone="dark" testid="gate-card-marks" />
        </div>
      </div>
    </footer>
  );
}

export function GateLegalView({ slug }) {
  return (
    <div className="flex min-h-screen flex-col bg-white" data-testid="gate-legal-view">
      <header className="no-print flex items-center justify-between bg-black px-6 py-4">
        <img src={LOGO} alt="CIArb Bahamas Branch" className="h-10 w-auto" />
        <Link to="/" className="text-sm text-white/80 underline-offset-4 hover:text-white hover:underline" data-testid="gate-legal-back-link">Back</Link>
      </header>
      <main className="flex-1"><LegalDocument slug={slug} /></main>
      <div className="no-print"><GateFooter /></div>
    </div>
  );
}
